/**
 * @prettier
 */

import React from 'react';

import styles from './ExpeditedShippingModal.module.less';

const ExpeditedShippingModal = () => (
  <div className={styles['content-wrapper']}>
    <h1 className={styles.title}>About Estimated Arrival Dates</h1>
    <p className={styles.text}>
      We display the earliest estimated arrival date for your cards. Estimates vary based on the
      processing time and fastest available shipping method for your selected card type and design
      customizations.
    </p>
    <p className={styles.text}>
      You can select your shipping method at checkout. All standard orders ship for free and are
      delivered within 5-10 business days. Expedited orders ship for $11.95 and are delivered within
      5 business days.{' '}
      <strong>All orders are delivered to you at the address you enter at checkout.</strong>
    </p>
    <div>
      <table className={styles.chart}>
        <thead>
          <tr className={styles.chart__header}>
            <th className={styles.chart__header__content}>Shipping Method</th>
            <th className={styles.chart__header__content}>Estimated Delivery</th>
            <th className={styles.chart__header__content}>Processing Time</th>
            <th className={styles.chart__header__content}>Shipping Time</th>
            <th className={styles.chart__header__content}>Shipping Rate</th>
          </tr>
        </thead>
        <tbody>
          <tr className={styles.chart__body}>
            <td className={styles.chart__body__content}>
              <strong>Standard</strong>
            </td>
            <td className={styles.chart__body__content}>5-10 days</td>
            <td className={styles.chart__body__content}>3 days</td>
            <td className={styles.chart__body__content}>2-7 days</td>
            <td className={styles.chart__body__content}>FREE</td>
          </tr>
          <tr className={styles.chart__body}>
            <td className={styles.chart__body__content}>
              <strong>Expedited</strong>
            </td>
            <td className={styles.chart__body__content}>5 days</td>
            <td className={styles.chart__body__content}>3 days</td>
            <td className={styles.chart__body__content}>2 days</td>
            <td className={styles.chart__body__content}>$11.95</td>
          </tr>
        </tbody>
      </table>
      <p className={styles.mention}>
        *Additional processing time may be needed for orders with design upgrades (eg. custom foil).
      </p>
    </div>
    <p className={styles.text}>
      Note: At this time, we do not ship internationally or to Alaska and Hawaii due to long
      shipping times. Please see our full shipping policies for more details.
    </p>
  </div>
);

export default ExpeditedShippingModal;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/ExpeditedShippingModal/ExpeditedShippingModal.jsx